import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import chevron from '../../../../../../assets/images/icons/arrow/chevron-right.svg';

export const useStyles = makeStyles(({
  palette, fontWeights, breakpoints,
}: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    listStyle: 'none',
    margin: 0,
    paddingLeft: 0,
    [breakpoints.up('md')]: {},
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    padding: '0.75rem 3.5rem 0.75rem 0.75rem',
    border: `1px solid ${palette.grey[400]}`,
    borderRadius: '1rem',
    background: `transparent no-repeat url(${chevron}) center`,
    backgroundPositionX: 'calc(100% - 1.625rem)',
    backgroundSize: '1rem auto',
    color: palette.text.primary,
    textAlign: 'left',
    textDecoration: 'none',
    '& strong': {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
  },
  callbackAction: {
    cursor: 'pointer',
  },
  listNote: {
    display: 'block',
    color: palette.grey['700'],
    fontSize: '0.85rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.regular,
  },
  iconWrapper: {
    lineHeight: 0,
    '& path': {
      fill: palette.secondary.dark,
    },
  },
}));
